export enum Profession {
  PLUMBER = 'Plumber',
  ELECTRICIAN = 'Electrician',
  HVAC_TECHNICIAN = 'HVAC Technician',
  LOCKSMITH = 'Locksmith',
  POOL_TECHNICIAN = 'Pool Technician',
  OTHERS = 'Others',
}

export interface PredefinedService {
  name: string;
  duration: string;
  description: string;
}

export const PROFESSION_SERVICES: Record<string, PredefinedService[]> = {
  [Profession.PLUMBER]: [
    {
      name: 'Blocked Drain Clearing',
      duration: '60',
      description: 'Clear clogged drains using tools or jetting',
    },
    {
      name: 'Leak Detection & Repair',
      duration: '60',
      description: 'Find and fix pipe leaks',
    },
    {
      name: 'Hot Water System Repair',
      duration: '90',
      description: 'Diagnose and fix hot water issues',
    },
    {
      name: 'Tap & Toilet Repair',
      duration: '45',
      description: 'Fix dripping taps or running toilets',
    },
    {
      name: 'Emergency Plumbing',
      duration: '60',
      description: 'Urgent plumbing issues (burst pipes etc.)',
    },
    {
      name: 'Pipe Installation',
      duration: '120',
      description: 'Install or replace piping systems',
    },
  ],
  [Profession.ELECTRICIAN]: [
    {
      name: 'Power Point Installation',
      duration: '60',
      description: 'Install new electrical outlets',
    },
    {
      name: 'Lighting Installation',
      duration: '60',
      description: 'Install or replace lights/fixtures',
    },
    {
      name: 'Switchboard Upgrade',
      duration: '120',
      description: 'Upgrade electrical panel for safety',
    },
    {
      name: 'Fault Finding',
      duration: '60',
      description: 'Diagnose electrical issues',
    },
    {
      name: 'Smoke Alarm Installation',
      duration: '45',
      description: 'Install or replace smoke alarms',
    },
    {
      name: 'Emergency Electrical',
      duration: '60',
      description: 'Urgent electrical repairs',
    },
  ],
  [Profession.HVAC_TECHNICIAN]: [
    {
      name: 'AC Installation (Split System)',
      duration: '180',
      description: 'Install air conditioning unit',
    },
    {
      name: 'AC Repair',
      duration: '90',
      description: 'Fix cooling/heating issues',
    },
    {
      name: 'AC Servicing',
      duration: '60',
      description: 'Clean and maintain system',
    },
    {
      name: 'Gas Leak Check',
      duration: '60',
      description: 'Inspect system for gas leaks',
    },
    {
      name: 'Duct Cleaning',
      duration: '120',
      description: 'Clean air ducts for airflow',
    },
  ],
  [Profession.LOCKSMITH]: [
    {
      name: 'Lockout Service',
      duration: '30',
      description: 'Unlock doors for locked-out customers',
    },
    {
      name: 'Lock Installation',
      duration: '60',
      description: 'Install new locks',
    },
    {
      name: 'Lock Repair',
      duration: '45',
      description: 'Fix damaged locks',
    },
    {
      name: 'Key Cutting',
      duration: '15',
      description: 'Duplicate keys',
    },
    {
      name: 'Emergency Locksmith',
      duration: '30',
      description: '24/7 urgent lock issues',
    },
  ],
  [Profession.POOL_TECHNICIAN]: [
    {
      name: 'Pool Cleaning',
      duration: '60',
      description: 'Clean pool, remove debris',
    },
    {
      name: 'Chemical Balancing',
      duration: '45',
      description: 'Adjust water chemistry',
    },
    {
      name: 'Equipment Check',
      duration: '60',
      description: 'Inspect pump, filter, system',
    },
    {
      name: 'Pool Repair',
      duration: '90',
      description: 'Fix leaks or equipment issues',
    },
    {
      name: 'Green Pool Recovery',
      duration: '120',
      description: 'Restore heavily dirty pools',
    },
  ],
};
